'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Overlay = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    position: absolute;\n    // needs to display Overlay over the pagination, dropdowns and searchIcon\n    z-index: 2;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    //  50% alpha transparence - https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4\n    background-color: ", "80;\n"], ["\n    position: absolute;\n    // needs to display Overlay over the pagination, dropdowns and searchIcon\n    z-index: 2;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    //  50% alpha transparence - https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4\n    background-color: ", "80;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var templateObject_1;

exports.Overlay = Overlay;
